import { Button } from '@/components/ui/button'

export const PricingCard = ({
  title,
  subtitle,
  price,
  frequency = '/ mo',
  features = [],
  buttonLabel,
  buttonLink,
  theme = '', // 'negative' | 'affirmative' | 'moderators'
  className = '',
  onClick,
  showPreviewBadge = false,
}) => {
  const textColor = theme ? `gradient-text-${theme}` : ''
  const bgColor = theme ? `gradient-bg-${theme}` : ''
  const borderColor = theme ? `border-${theme}` : ''

  return (
    <div
      className={`relative flex flex-col justify-between border bg-card dark:bg-accent rounded-2xl shadow-md p-6 sm:p-8 w-full min-w-[280px] max-w-[400px] mx-auto text-center ${borderColor} ${className}`}
    >
      {showPreviewBadge && (
        <div className="absolute top-0 right-0 translate-x-1/2 -translate-y-1/2 z-10">
          <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded border-2 border-red-700 shadow-lg rotate-12 inline-block">
            Limited Time Preview Price!
          </span>
        </div>
      )}
      <div>
        <div className="flex flex-col items-center space-y-2">
          <h3 className="text-2xl sm:text-3xl font-bold">{title}</h3>
          <p className="text-gray-400 font-medium text-sm sm:text-base">{subtitle}</p>
          <div className={`text-4xl sm:text-5xl font-bold mt-2 ${textColor}`}>
            ${price}
            <span className="text-lg font-normal"> {frequency}</span>
            {frequency === '/ yr' && price !== 0 && (
              <div className="text-sm text-green-500 font-semibold mt-1">Save 25%</div>
            )}
          </div>
        </div>

        <ul className="text-sm sm:text-base font-semibold text-center space-y-3 mt-6">
          {features.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
      <div className="mt-8 w-full">
        {buttonLink ? (
          <a href={buttonLink} className="w-full block">
            <Button
              variant="outline"
              className={`w-full ${bgColor} text-white hover:text-white py-2 px-4 rounded-full font-semibold hover:opacity-90 transition`}
            >
              {buttonLabel}
            </Button>
          </a>
        ) : (
          <div className="w-full block">
            <Button
              onClick={onClick}
              variant="outline"
              className={`w-full ${bgColor} text-white hover:text-white py-2 px-4 rounded-full font-semibold hover:opacity-90 transition`}
            >
              {buttonLabel}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
